<template>
  <div>
    <card title="Servicios de Transportes" icon="fas fa-truck">
        <master-options @showModal="showModal" :links="links" @index="index" @reset="reset"></master-options>
        <div class="table-responsive" >
          <manage-table :hover="true" :headers="['Id','Nombre','Url', 'Interno']"
                                :hasOptions="true" >
              <tr v-for="courier in ListCouriers" :key="courier.id">
                <td>{{ courier.id }}</td>
                <td>{{ courier.name }}</td>
                <td>{{ courier.url }}</td>
                <td>
                  <span v-if="courier.internal"><i class="fas fa-check"></i></span>
                </td>
                <td>
                    <button class="btn btn-info btn-sm mr-2" @click="showModal(courier)" data-toggle="tooltip" data-placement="top" title="Editar Objetivo de Muestra">
                        <i class="fas fa-edit"></i>
                    </button>
                    <button title="Eliminar Objetivo de Muestra" class="btn btn-danger btn-sm " @click="deleteCourier(courier.id, courier.name)" data-toggle="tooltip" data-placement="top">
                        <i class="fas fa-trash"></i>
                    </button>
                </td>
              </tr>
          </manage-table>
        </div>
         <paginator class="mt-4" :links="links"></paginator>
    </card>
    <modal id="courierFormModal" :title="modalTitle" @modalClose="index">
        <courier-form :courier="courier" @pressOk="save"></courier-form>
    </modal>
  </div>
</template>

<script>
import { Get, Delete, Post, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import $ from "jquery";
import {getUrlQuery} from "../../helper/queryHelper";
export default {
  components: {
    Card
  },
  data() {
    return {
      ListCouriers: [],
      Post,
      Delete,
      apiUrl: this.$store.getters.apiUrl,
      modalTitle: '',
      Get,
      Put,
      courier: {},
      links: {},
      getUrlQuery
    };
  },
  watch:{
    urlQuery:function(){
      this.index()
    }
  },
  created() {
    this.index();
  },
  methods: {
    index() {
      this.$store.commit("setLoading", true);   
      this.Get(this.apiUrl + "v1/courier?" + this.urlQuery, res => {
          this.ListCouriers = res.data.data;
          this.links = res.data.links;
          this.$store.commit("setLoading", false);
      });
        
    },
    reset() {
      this.links = {}
      this.index()
    },
    save() {  
      if(this.courier.id)
        this.update()
      else
        this.store()
                    
    },
    showModal(courier) {
      if (courier && courier.id) {
        this.modalTitle = "Actualizar Courier";
        this.courier = courier;
      } else {
        this.modalTitle = "Crear Courier";
        this.courier = {};
      }
      $('#courierFormModal').modal('show');
    },
    deleteCourier(id, name) {
      this.$swal({
        title: "¿Desea eliminar el Servicio de Transporte?",
        text: name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33"
      }).then(result => {
        if (result.value) {
           this.Delete(this.apiUrl +'v1/courier/'+id, () => {
             window.toastr.success('Courier Eliminado correctamente.');
             this.index();
           });
           
        }
        
      });
    },
    update(){
      this.$store.commit("setLoading", true);
      this.Put(this.apiUrl+"v1/courier/" + this.courier.id, this.courier, () =>{
        $('#courierFormModal').modal('hide');
        this.$store.commit("setLoading", false);
        window.toastr.success('Courier Actualizado correctamente.');
        this.reset();
      });
    },
    store(){
      this.$store.commit("setLoading", true);
      this.Post(`${this.apiUrl}v1/courier/`, this.courier, () =>{
          this.courier = {}; 
          $('#courierFormModal').modal('hide');
          this.$store.commit("setLoading", false);
          window.toastr.success('Courier Registrado correctamente.');
           this.reset();
      });
    }
  },
  computed:{
    urlQuery(){
        return this.getUrlQuery()
    }
  }

}

</script>